export const StorageKeyName = "cookie_consent";

export const hasAcceptedCookies = () => localStorage.getItem(StorageKeyName) === "true";
